import React, { useEffect, useState, useCallback, useRef } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import "./adminPage.css";
import {
  createAuthUser,
  fbLogin,
  requestPasswordReset,
  searchUsers,
  adminChangesUserData,
  pullUserData,
  doSmth,
  readStats,
  verifyEmailManually,
  exportAllUsersToExcel,
  exportyfResultUsersToExcel,
  exportFinalResultUsersToExcel,
  exportFinalCarPlatesToExcel,
  exportExamRoomUsersToExcel,
  exportExamLinksToExcel,
  getElemeSuccessfulEmailsYf,
  getYfSuccessfulEmailsFn,
  fetchActiveProduct,
  updateExamInfo,
  getAllUsers,
  impersonateUser,
  adminBulkUpdateElemeSonuc,
  adminBulkUpdateYfSonuc,
  adminBulkUpdateExamRoomInfo,
  getFinalPuanUsers,
  adminSetFinalPuan,
  adminSaveFinalRanks,
  adminClearFinalRanks,
  adminSetOdulGonderimi,
  getHallOfFameUsers,
  getCategoryForBirthYear,
} from "../../db/firebaseMethods";
import AppContext from "../../AppContext";
import { formatShippingAddress } from "../../utils/utils";
import LoadingBlock from "../../components/organisms/loadingBlock/loadingBlock";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import Chip from "@mui/material/Chip";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";

export default function AdminPage() {
  const [state, setStateValues] = useState({
    searchString: "",
    users: [],
    selectedUser: null,
    newPass: null,
    newEmail: null,
    isLoadingVisible: false,
    selectedTabIndex: 0,
  });

  const setState = (obj) => {
    setStateValues({
      ...state,
      ...obj,
    });
  };

  const { setCentralState, user } = React.useContext(AppContext);
  // if (!user && user.) return <Navigate replace to="/profile" />;

  const onRowSelected = async (u) => {
    let selectedUser = await pullUserData(u.objectID);
    setState({ selectedUser });
    // console.log("selectedUser", selectedUser);
  };

  const searchOnAlgolia = async () => {
    if (!user.algolia_search_api_key)
      alert("User tablonuzda Api key yok. Yavuza bilgi verin, eklsin :)");
    else {
      const users = await searchUsers(
        user.algolia_search_api_key,
        state.searchString
      );
      // console.log("users", users);
      setState({ users, selectedUser: null });
    }
  };

  // const buttonForDeveloper = user?.email === "yavuz@halici.com.tr" && (
  //   <div
  //     style={{
  //       display: "flex",
  //       justifyContent: "flex-start",
  //       marginLeft: 10,
  //     }}
  //   >
  //     <Button
  //       style={{ marginTop: 20, marginBottom: 50, width: 120 }}
  //       onClick={doSmth}
  //       color="secondary"
  //       variant="contained"
  //     >
  //       BASMA SAKIN!
  //     </Button>
  //   </div>
  // );
  const buttonForElemeEmails = (
    <Button
      style={{
        marginTop: 20,
        marginBottom: 50,
        marginLeft: 20,
        width: 240,
      }}
      onClick={getYfSuccessfulEmailsFn}
      color="secondary"
      variant="contained"
    >
      Eleme Başarılı Olanları İndir
    </Button>
  );

  const buttonForAdmin = (
    <Button
      style={{
        marginTop: 20,
        marginBottom: 50,
        marginLeft: 20,
        width: 160,
      }}
      onClick={exportAllUsersToExcel}
      color="secondary"
      variant="contained"
    >
      TÜM KULLANICI LİSTESİNİ İNDİR
    </Button>
  );

  // GriCeviz Turnuvası Kullanıcı Listesi butonu
  const downloadGricevizUsers = async () => {
    const allUsers = await getAllUsers();
    const gricevizUsers = (allUsers || []).filter(
      (u) =>
        u.products &&
        u.products.oyun2026 &&
        u.products.oyun2026.is_paid === true &&
        u.email
    );
    const data = gricevizUsers.map((u) => ({ Email: u.email }));
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Kullanicilar");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "griceviz_turnuvasi_kullanicilari.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const buttonForGricevizUsers = (
    <Button
      style={{
        marginTop: 20,
        marginBottom: 50,
        marginLeft: 20,
        width: 260,
        backgroundColor: "#582b71",
        color: "#fff",
        fontWeight: "bold",
      }}
      onClick={downloadGricevizUsers}
      variant="contained"
    >
      GriCeviz Turnuvası Kullanıcı Listesi
    </Button>
  );

  const userListBox = (
    <div className="userListBox">
      <div style={{ display: "flex" }}>
        {/* {buttonForDeveloper} */}
        {buttonForAdmin}
        {/*  {buttonForGricevizUsers}*/}
        {/* {buttonForElemeEmails} */}
      </div>
      <div className="searchRow">
        <TextField
          id="searchString"
          label="Ad-Soyad-Email-Telefon"
          // name="searchString"
          // defaultValue={newName}
          value={state?.searchString}
          onChange={(e) => setState({ searchString: e.target.value })}
          autoComplete={"disabled"}
          style={{ width: 400, marginRight: 5 }}
          size="small"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              searchOnAlgolia();
            }
          }}
        />
        <Button
          variant="contained"
          disabled={state?.searchString.length < 4}
          onClick={searchOnAlgolia}
        >
          ARA
        </Button>
      </div>

      {state?.users?.length > 0 &&
        generateUserTable(state?.users, onRowSelected)}
    </div>
  );

  return (
    <div className="pageBox">
      <Tabs
        value={state?.selectedTabIndex}
        onChange={(event, newValue) => {
          setState({ selectedTabIndex: newValue });
        }}
        aria-label="basic tabs example"
        // Sekmeler yana kaymasın, sığmayanlar alt satıra geçsin. Alt çizgi
        // satır kırılınca kaydığı için gizlendi; seçili sekme arka planla belirtiliyor.
        TabIndicatorProps={{ style: { display: "none" } }}
        sx={{
          "& .MuiTabs-flexContainer": { flexWrap: "wrap", gap: "4px" },
          "& .MuiTab-root": {
            minHeight: 40,
            padding: "6px 12px",
            borderRadius: "8px",
          },
          "& .MuiTab-root.Mui-selected": {
            backgroundColor: "#f0e6f7",
            color: "#582b71",
            fontWeight: 700,
          },
        }}
      >
        <Tab label="KULLANICILAR" />
        <Tab label="İSTATİSTİKLER" />
        <Tab label="AKTİF SINAV BİLGİLERİ" />
        <Tab label="ELEME SONUÇLARI" />
        <Tab label="YARI FİNAL SONUÇLARI" />
        <Tab label="SINAV SALON BİLGİLERİ" />
        <Tab label="SINAV LİNKLERİ" />
        <Tab label="FİNAL PUANLARI" />
      </Tabs>

      <TabPanel value={state?.selectedTabIndex} index={0}>
        <div className="usersTab">
          {userListBox}
          {state?.selectedUser && (
            <SingleUserBox selectedUser={state?.selectedUser} />
          )}
        </div>
      </TabPanel>

      <TabPanel value={state?.selectedTabIndex} index={1}>
        <StatsTab />
      </TabPanel>

      <TabPanel value={state?.selectedTabIndex} index={2}>
        <EditExamInfoBox />
      </TabPanel>

      <TabPanel value={state?.selectedTabIndex} index={3}>
        <BulkElemeResultBox />
      </TabPanel>

      <TabPanel value={state?.selectedTabIndex} index={4}>
        <BulkYfResultBox />
      </TabPanel>

      <TabPanel value={state?.selectedTabIndex} index={5}>
        <BulkExamRoomInfoBox />
      </TabPanel>

      <TabPanel value={state?.selectedTabIndex} index={6}>
        <ExamLinksBox />
      </TabPanel>

      <TabPanel value={state?.selectedTabIndex} index={7}>
        <FinalScoresBox />
      </TabPanel>
    </div>
  );
}

const generateUserTable = (users, onRowSelected) => {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell style={{ fontWeight: "bold" }}>E-mail</TableCell>
            <TableCell style={{ fontWeight: "bold" }}>Ad-Soyad</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {users.map((u) => (
            <TableRow
              hover
              key={u.email}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              className="tableRow"
              onClick={() => {
                onRowSelected(u);
              }}
            >
              <TableCell component="th" scope="row">
                {u.email}
              </TableCell>
              <TableCell>{u.name}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const SingleUserBox = (props) => {
  const { selectedUser } = props;
  const [state, setStateValues] = useState({
    newPass: "",
    newEmail: "",
    isLoadingVisible: false,
  });

  const setState = (obj) => {
    setStateValues({
      ...state,
      ...obj,
    });
  };

  const changePass = async () => {
    setState({ isLoadingVisible: true });
    const res = await adminChangesUserData({
      userId: selectedUser.uid,
      competitorNewPass: state.newPass,
    });
    alert(res);
    setState({ isLoadingVisible: false, newPass: "" });
  };

  const changeEmail = async () => {
    const newEmail = state.newEmail.trim();
    if (!/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(newEmail)) {
      alert("Geçerli bir e-posta adresi yazınız!");
    } else {
      setState({ isLoadingVisible: true });
      const res = await adminChangesUserData({
        userId: selectedUser.uid,
        newEmail,
      });
      alert(res);
      setState({ isLoadingVisible: false, newEmail: "" });
    }
  };

  const setEmailAsVerified = async () => {
    setState({ isLoadingVisible: true });
    const res = await verifyEmailManually(selectedUser.uid);
    alert(res);
    setState({ isLoadingVisible: false, newPass: "" });
  };

  const handleImpersonate = async () => {
    setState({ isLoadingVisible: true });
    try {
      const token = await impersonateUser(selectedUser.uid);
      const url = `${window.location.origin}/impersonate?t=${encodeURIComponent(
        token
      )}`;
      window.open(url, "_blank");
    } catch (err) {
      alert("Hata: " + err.message);
    }
    setState({ isLoadingVisible: false });
  };

  let paidProducts = [];
  if (selectedUser.products) {
    Object.keys(selectedUser.products).forEach((productName) => {
      const isPaid = selectedUser.products[productName].is_paid;
      if (isPaid) paidProducts.push(productName);
    });
  }

  return (
    <div className="singleUserBox">
      {state.isLoadingVisible && <LoadingBlock />}
      <div style={{ marginBottom: 15, width: "100%" }}>
        --- SEÇİLEN KULLANICI ---
      </div>
      <div className="singleUserDataRow">{selectedUser.uid}</div>
      <div className="singleUserDataRow">
        {selectedUser.name || "Henüz Ad-Soyad Kaydedilmemiş!"}
      </div>
      <div className="singleUserDataRow">{selectedUser.email}</div>
      <div className="singleUserDataRow">
        <span className="lbl">Tel</span>
        {selectedUser.phone || ""}
      </div>
      <div className="singleUserDataRow">
        <span className="lbl">Doğum Yılı</span>
        {selectedUser.birth_year || ""}
      </div>
      {/* <div className="singleUserDataRow">
        <span className="lbl">Cinsiyet</span>
        {selectedUser.gender || ""}
      </div>
      <div className="singleUserDataRow">
        <span className="lbl">Eğitim</span>
        {selectedUser.education || ""}
      </div>
      <div className="singleUserDataRow">
        <span className="lbl">Meslek</span>
        {selectedUser.occupation || ""}
      </div>
      <div className="singleUserDataRow">
        <span className="lbl">Şehir</span>
        {selectedUser.city || ""}
      </div> */}
      {paidProducts.map((p) => (
        <div
          key={p + "users_productss"}
          style={{ display: "flex", alignItems: "center" }}
        >
          {p + " ödemesi: "}{" "}
          <CheckCircleOutlineIcon style={{ color: "green" }} />
        </div>
      ))}

      <div style={{ marginTop: 20, display: "flex" }}>
        <TextField
          id="newPass"
          label="Yeni Şifre"
          value={state.newPass}
          onChange={(e) => setState({ newPass: e.target.value })}
          autoComplete={"disabled"}
          style={{ width: 200, marginRight: 5 }}
          size="small"
        />
        {state.newPass && state.newPass.length > 5 && (
          <Button
            style={{ textTransform: "none" }}
            color="secondary"
            variant="contained"
            onClick={changePass}
          >
            Değiştir
          </Button>
        )}
      </div>

      <div style={{ marginTop: 20, display: "flex" }}>
        <TextField
          id="newEmail"
          label="Yeni Email"
          value={state.newEmail}
          onChange={(e) => setState({ newEmail: e.target.value })}
          autoComplete={"disabled"}
          style={{ width: 200, marginRight: 5 }}
          size="small"
        />
        {state.newEmail && state.newEmail.length > 5 && (
          <Button
            style={{ textTransform: "none" }}
            color="secondary"
            variant="contained"
            onClick={changeEmail}
          >
            Değiştir
          </Button>
        )}
      </div>

      <Button
        variant="contained"
        style={{ textTransform: "none", marginTop: 20 }}
        onClick={setEmailAsVerified}
      >
        Eposta Adresini Doğrula
      </Button>
      <Button
        variant="outlined"
        color="warning"
        style={{ textTransform: "none", marginTop: 10 }}
        onClick={handleImpersonate}
      >
        Bu kullanıcı olarak giriş yap (yeni sekme)
      </Button>
    </div>
  );
};

const StatsTab = () => {
  const [userCountsDaily, setUserCountsDaily] = useState([]);
  const [latestCounts, setLatestCounts] = useState([0, 0]);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const stats = await readStats();
        const userCounts = stats?.user_counts;

        if (!userCounts || userCounts.length === 0) return;

        setLatestCounts([
          userCounts[userCounts.length - 1].total_users,
          userCounts[userCounts.length - 1].total_payments,
        ]);

        const userCountsDaily = userCounts.map((u, i) => {
          if (i === 0) return u;
          const previous_u = userCounts[i - 1];
          return {
            date_and_time: u.date_and_time,
            total_users: u.total_users - previous_u.total_users,
            total_payments: u.total_payments - previous_u.total_payments,
          };
        });

        setUserCountsDaily(userCountsDaily);
      } catch (err) {
        console.error("Stats yüklenirken hata:", err);
      }
    };

    fetchStats();
  }, []);

  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      // title: {
      //     display: true,
      //     text: 'Günlük Sayılar',
      // },
    },
  };

  const data2 = {
    labels: userCountsDaily.map((u) =>
      u.date_and_time.toDate().toLocaleDateString("tr-TR", {
        timeZone: "Europe/Istanbul",
        month: "2-digit",
        day: "2-digit",
        year: "numeric",
      })
    ),
    datasets: [
      {
        label: "Kayıt",
        data: userCountsDaily.map((u) => u.total_users),
        backgroundColor: "rgba(255, 99, 132, 0.5)",
      },
      {
        label: "Ödeme",
        data: userCountsDaily.map((u) => u.total_payments),
        backgroundColor: "rgba(53, 162, 235, 0.5)",
      },
    ],
  };

  return (
    <div className="statsTab">
      <div>{"Kayıtlı kullanıcılar: " + latestCounts[0]}</div>
      <div>{"Ödeme yapanlar: " + latestCounts[1]}</div>
      <div>{"(Sayılar her gün saat 23.59'da güncellenmektedir.)"}</div>
      <Bar options={options} data={data2} />
    </div>
  );
};
const EditExamInfoBox = () => {
  const { user } = React.useContext(AppContext);
  const [activeProduct, setActiveProduct] = useState(null);
  const [expo, setExpo] = useState("");
  const [title, setTitle] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [selectedExamIndex, setSelectedExamIndex] = useState(0);

  useEffect(() => {
    const getProduct = async () => {
      setIsLoading(true);
      const product = await fetchActiveProduct("admin");
      setActiveProduct(product);
      if (product && product.exams && product.exams.length > 0) {
        setExpo(product.exams[0].expo || "");
        setTitle(product.exams[0].title || "");
      }
      setIsLoading(false);
    };
    getProduct();
  }, []);

  useEffect(() => {
    if (
      activeProduct &&
      activeProduct.exams &&
      activeProduct.exams.length > selectedExamIndex
    ) {
      setExpo(activeProduct.exams[selectedExamIndex].expo || "");
      setTitle(activeProduct.exams[selectedExamIndex].title || "");
    } else {
      setExpo("");
      setTitle("");
    }
  }, [selectedExamIndex, activeProduct]);

  const handleSave = async () => {
    if (!activeProduct) {
      toast.error("Aktif ürün bulunamadı.");
      return;
    }
    setIsLoading(true);
    const result = await updateExamInfo(activeProduct.id, selectedExamIndex, {
      expo,
      title,
    });
    if (result === "Sınav bilgileri başarıyla güncellendi!") {
      toast.success(result);
    } else {
      toast.error(result);
    }
    setIsLoading(false);
  };

  if (user?.role !== "admin") {
    return (
      <div>
        <h3>Yetkisiz Erişim</h3>
        <p>Bu sayfaya erişim izniniz bulunmamaktadır.</p>
      </div>
    );
  }

  return (
    <div>
      <h3>Sınav Bilgileri Düzenleme</h3>
      <p>
        Aktif sezonlar burada listeleniyor. Sınav bilgilerini düzenlemek için
        iligli sınavı seçiniz. Gerekli bilgileri düzenleyiniz.
      </p>
      {isLoading && <LoadingBlock />}
      {activeProduct &&
      activeProduct.exams &&
      activeProduct.exams.length > 0 ? (
        <>
          <Select
            value={selectedExamIndex}
            onChange={(e) => setSelectedExamIndex(e.target.value)}
            displayEmpty
            inputProps={{ "aria-label": "Without label" }}
            fullWidth
            margin="normal"
            sx={{
              backgroundColor: "#f9f4ff",
              color: "black",
              fontWeight: "bold",
              height: 40,
              fontSize: 14,
            }}
          >
            {activeProduct.exams.map((exam, index) => (
              <MenuItem
                key={index}
                value={index}
                sx={{
                  fontWeight: "bold",
                  fontSize: 13,
                }}
              >
                {exam.title || `Sınav ${index + 1}`}
              </MenuItem>
            ))}
          </Select>
          <TextField
            label="Sınav Adı"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Sınav Açıklaması"
            value={expo}
            onChange={(e) => setExpo(e.target.value)}
            fullWidth
            multiline
            rows={4}
            margin="normal"
          />
          <Button
            className="historyButton"
            onClick={handleSave}
            disabled={isLoading}
          >
            Kaydet
          </Button>
        </>
      ) : (
        <p>Aktif sınav bilgisi bulunmamaktadır.</p>
      )}
      <ToastContainer />
    </div>
  );
};

const BulkElemeResultBox = () => {
  const { user } = React.useContext(AppContext);
  const [activeProduct, setActiveProduct] = useState(null);
  const [fileName, setFileName] = useState("");
  const [parsedRows, setParsedRows] = useState([]);
  const [invalidRowCount, setInvalidRowCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [resultSummary, setResultSummary] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    const getProduct = async () => {
      const product = await fetchActiveProduct("admin");
      setActiveProduct(product);
    };
    getProduct();
  }, []);

  const findColumnValue = (row, candidates) => {
    const keys = Object.keys(row);
    for (const candidate of candidates) {
      const foundKey = keys.find((k) => k.trim().toLowerCase() === candidate);
      if (foundKey !== undefined) return row[foundKey];
    }
    return undefined;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setFileName(file.name);
    setResultSummary(null);
    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(sheet, { defval: "" });

      const rows = [];
      let invalid = 0;
      json.forEach((row) => {
        const uid = findColumnValue(row, [
          "user_id",
          "uid",
          "kullanıcı_id",
          "kullanici_id",
        ]);
        const elemeRaw = findColumnValue(row, [
          "eleme_sonuc",
          "eleme_durumu",
          "durum",
        ]);
        const eleme_sonuc = Number(elemeRaw);
        if (!uid || !Number.isFinite(eleme_sonuc)) {
          invalid++;
          return;
        }
        rows.push({ uid: uid.toString().trim(), eleme_sonuc });
      });
      setParsedRows(rows);
      setInvalidRowCount(invalid);
    };
    reader.readAsArrayBuffer(file);
  };

  const handleDownloadSample = () => {
    const sampleData = [
      { user_id: "Ab12Cd34Ef56Gh78Ij90KlMnOpQr", eleme_sonuc: 1 },
      { user_id: "Zy98Xw76Vu54Ts32Rq10PoNmLkJi", eleme_sonuc: 2 },
    ];
    const worksheet = XLSX.utils.json_to_sheet(sampleData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Eleme Sonuclari");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "eleme_sonuclari_ornek.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleExportYfCandidates = async () => {
    if (!activeProduct?.id) {
      toast.error("Aktif ürün bulunamadı.");
      return;
    }
    setIsLoading(true);
    try {
      const examAccessIds = activeProduct?.exams?.[0]?.exam_access_ids;
      const rows = await exportyfResultUsersToExcel(
        activeProduct.id,
        examAccessIds
      );
      if (!rows || rows.length === 0) {
        toast.info("Yarı Final aşamasına hak kazanan kullanıcı bulunamadı.");
      } else {
        toast.success(`${rows.length} kullanıcı Excel'e aktarıldı.`);
      }
    } catch (err) {
      toast.error("Excel oluşturulurken hata oluştu: " + err.message);
    }
    setIsLoading(false);
  };

  const handleUpload = async () => {
    if (!activeProduct?.id) {
      toast.error("Aktif ürün bulunamadı.");
      return;
    }
    if (parsedRows.length === 0) {
      toast.error("Yüklenecek geçerli satır bulunamadı.");
      return;
    }
    setIsLoading(true);
    try {
      const res = await adminBulkUpdateElemeSonuc(activeProduct.id, parsedRows);
      if (res.error) {
        toast.error(res.error);
      } else {
        setResultSummary(res);
        toast.success(res.result);
      }
    } catch (err) {
      toast.error("Güncelleme sırasında hata oluştu: " + err.message);
    }
    setIsLoading(false);
  };

  if (user?.role !== "admin") {
    return (
      <div>
        <h3>Yetkisiz Erişim</h3>
        <p>Bu sayfaya erişim izniniz bulunmamaktadır.</p>
      </div>
    );
  }

  const hasFile = !!fileName;

  return (
    <div>
      <div
        style={{
          maxWidth: 820,
          border: "1px solid #e3d9ee",
          borderRadius: 12,
          padding: "24px 28px",
          marginTop: 10,
          marginBottom: 24,
          background: "#fff",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <h3 style={{ margin: 0, color: "#582b71" }}>
            Yarı Final Aşamasına Kalanlar
          </h3>
          <Chip
            size="small"
            label={activeProduct?.id || "aktif ürün yok"}
            style={{
              backgroundColor: "#582b71",
              color: "#fff",
              fontWeight: 600,
            }}
          />
        </div>
        <p style={{ color: "#555", fontSize: 14, lineHeight: 1.6 }}>
          Eleme sonucu <strong>başarılı (1)</strong> olan, yani Yarı Final
          aşamasına hak kazanan kullanıcıların{" "}
          <strong>UID, Ad-Soyad, Email ve Kategori</strong> bilgilerini Excel
          olarak indirir.
        </p>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<FileDownloadIcon />}
          disabled={isLoading || !activeProduct?.id}
          style={{ textTransform: "none", fontWeight: 600 }}
          onClick={handleExportYfCandidates}
        >
          Yarı Final'e Kalanları İndir (Excel)
        </Button>
      </div>

      <div
        style={{
          maxWidth: 820,
          border: "1px solid #e3d9ee",
          borderRadius: 12,
          padding: "24px 28px",
          marginTop: 10,
          background: "#fff",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <h3 style={{ margin: 0, color: "#582b71" }}>
            Eleme Sınavı Sonuçlarını Toplu Yükle
          </h3>
          <Chip
            size="small"
            label={activeProduct?.id || "aktif ürün yok"}
            style={{
              backgroundColor: "#582b71",
              color: "#fff",
              fontWeight: 600,
            }}
          />
        </div>
        <p style={{ color: "#555", fontSize: 14, lineHeight: 1.6 }}>
          Excel dosyasında <strong>user_id</strong> (kullanıcının uid'si) ve{" "}
          <strong>eleme_sonuc</strong> (örn. 1 = başarılı, 2 = elendi) sütunları
          olmalıdır. Emin değilsen önce örnek dosyayı indirip formatı kontrol
          edebilirsin.
        </p>

        <Button
          variant="text"
          color="secondary"
          startIcon={<FileDownloadIcon />}
          style={{ textTransform: "none", paddingLeft: 0 }}
          onClick={handleDownloadSample}
        >
          Örnek Excel İndir
        </Button>

        <div
          style={{
            marginTop: 16,
            border: "2px dashed #c8b6dc",
            borderRadius: 10,
            padding: "24px 20px",
            textAlign: "center",
            background: "#faf7fc",
          }}
        >
          <input
            ref={fileInputRef}
            type="file"
            accept=".xlsx,.xls,.csv"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          {!hasFile ? (
            <>
              <CloudUploadIcon style={{ fontSize: 40, color: "#8a63a8" }} />
              <div
                style={{ margin: "8px 0 16px", color: "#555", fontSize: 14 }}
              >
                Yüklemek istediğin Excel/CSV dosyasını seç
              </div>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => fileInputRef.current?.click()}
                style={{ textTransform: "none", fontWeight: 600 }}
              >
                Dosya Seç
              </Button>
            </>
          ) : (
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                  fontWeight: 600,
                  color: "#333",
                }}
              >
                <InsertDriveFileIcon style={{ color: "#8a63a8" }} />
                {fileName}
              </div>
              <div
                style={{
                  marginTop: 10,
                  display: "flex",
                  justifyContent: "center",
                  gap: 8,
                  flexWrap: "wrap",
                }}
              >
                <Chip
                  size="small"
                  icon={<TaskAltIcon style={{ color: "#2e7d32 !important" }} />}
                  label={`${parsedRows.length} geçerli satır`}
                  style={{ backgroundColor: "#e6f4ea", color: "#2e7d32" }}
                />
                {invalidRowCount > 0 && (
                  <Chip
                    size="small"
                    icon={
                      <ErrorOutlineIcon
                        style={{ color: "#c66500 !important" }}
                      />
                    }
                    label={`${invalidRowCount} satır atlandı`}
                    style={{ backgroundColor: "#fdf0e0", color: "#c66500" }}
                  />
                )}
              </div>
              <Button
                variant="text"
                size="small"
                color="secondary"
                style={{ marginTop: 10, textTransform: "none" }}
                onClick={() => fileInputRef.current?.click()}
              >
                Başka dosya seç
              </Button>
            </div>
          )}
        </div>

        {isLoading && <LoadingBlock />}

        {parsedRows.length > 0 && (
          <>
            <TableContainer
              component={Paper}
              variant="outlined"
              style={{ marginTop: 20, maxHeight: 320 }}
            >
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: "bold" }}>
                      Kullanıcı ID
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>
                      Eleme Sonucu
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {parsedRows.slice(0, 50).map((r, i) => (
                    <TableRow
                      key={r.uid + i}
                      hover
                      style={{
                        backgroundColor: i % 2 === 0 ? "#fff" : "#faf8fc",
                      }}
                    >
                      <TableCell style={{ fontFamily: "monospace" }}>
                        {r.uid}
                      </TableCell>
                      <TableCell>
                        <Chip
                          size="small"
                          label={r.eleme_sonuc}
                          style={{
                            backgroundColor:
                              r.eleme_sonuc === 1 ? "#e6f4ea" : "#f0e6f7",
                            color: r.eleme_sonuc === 1 ? "#2e7d32" : "#582b71",
                            fontWeight: 600,
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            {parsedRows.length > 50 && (
              <div style={{ marginTop: 6, fontSize: 12, color: "#777" }}>
                Önizlemede ilk 50 satır gösteriliyor, toplam {parsedRows.length}{" "}
                satır güncellenecek.
              </div>
            )}
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              style={{
                marginTop: 18,
                padding: "10px 0",
                fontWeight: 700,
                textTransform: "none",
              }}
              disabled={isLoading}
              onClick={handleUpload}
            >
              {parsedRows.length} Kullanıcıyı Güncelle
            </Button>
          </>
        )}

        {resultSummary && (
          <div
            style={{
              marginTop: 20,
              padding: "16px 18px",
              background: "#f5f0f9",
              border: "1px solid #e3d9ee",
              borderRadius: 10,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                fontWeight: 700,
                color: "#2e7d32",
              }}
            >
              <TaskAltIcon />
              {resultSummary.updated} kullanıcı güncellendi
            </div>
            {resultSummary.invalidCount > 0 && (
              <div style={{ marginTop: 6, fontSize: 13, color: "#c66500" }}>
                {resultSummary.invalidCount} satır geçersiz olduğu için atlandı.
              </div>
            )}
            {resultSummary.notFound?.length > 0 && (
              <div style={{ marginTop: 6, fontSize: 13, color: "#b3261e" }}>
                Bulunamayan kullanıcı id'leri ({resultSummary.notFound.length}):{" "}
                <span style={{ fontFamily: "monospace" }}>
                  {resultSummary.notFound.join(", ")}
                </span>
              </div>
            )}
          </div>
        )}
        <ToastContainer />
      </div>
    </div>
  );
};

const BulkYfResultBox = () => {
  const { user } = React.useContext(AppContext);
  const [activeProduct, setActiveProduct] = useState(null);
  const [fileName, setFileName] = useState("");
  const [parsedRows, setParsedRows] = useState([]);
  const [invalidRowCount, setInvalidRowCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [resultSummary, setResultSummary] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    const getProduct = async () => {
      const product = await fetchActiveProduct("admin");
      setActiveProduct(product);
    };
    getProduct();
  }, []);

  const findColumnValue = (row, candidates) => {
    const keys = Object.keys(row);
    for (const candidate of candidates) {
      const foundKey = keys.find((k) => k.trim().toLowerCase() === candidate);
      if (foundKey !== undefined) return row[foundKey];
    }
    return undefined;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setFileName(file.name);
    setResultSummary(null);
    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(sheet, { defval: "" });

      const rows = [];
      let invalid = 0;
      json.forEach((row) => {
        const uid = findColumnValue(row, [
          "user_id",
          "uid",
          "kullanıcı_id",
          "kullanici_id",
        ]);
        const yfRaw = findColumnValue(row, ["yf_sonuc", "yf_durumu", "durum"]);
        const yf_sonuc = Number(yfRaw);
        if (!uid || !Number.isFinite(yf_sonuc)) {
          invalid++;
          return;
        }
        rows.push({ uid: uid.toString().trim(), yf_sonuc });
      });
      setParsedRows(rows);
      setInvalidRowCount(invalid);
    };
    reader.readAsArrayBuffer(file);
  };

  const handleDownloadSample = () => {
    const sampleData = [
      { user_id: "Ab12Cd34Ef56Gh78Ij90KlMnOpQr", yf_sonuc: 1 },
      { user_id: "Zy98Xw76Vu54Ts32Rq10PoNmLkJi", yf_sonuc: 2 },
    ];
    const worksheet = XLSX.utils.json_to_sheet(sampleData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Yari Final Sonuclari");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "yf_sonuclari_ornek.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleExportFinalCandidates = async () => {
    if (!activeProduct?.id) {
      toast.error("Aktif ürün bulunamadı.");
      return;
    }
    setIsLoading(true);
    try {
      const examAccessIds = activeProduct?.exams?.[0]?.exam_access_ids;
      const rows = await exportFinalResultUsersToExcel(
        activeProduct.id,
        examAccessIds
      );
      if (!rows || rows.length === 0) {
        toast.info("Final aşamasına hak kazanan kullanıcı bulunamadı.");
      } else {
        toast.success(`${rows.length} kullanıcı Excel'e aktarıldı.`);
      }
    } catch (err) {
      toast.error("Excel oluşturulurken hata oluştu: " + err.message);
    }
    setIsLoading(false);
  };

  const handleExportFinalCarPlates = async () => {
    if (!activeProduct?.id) {
      toast.error("Aktif ürün bulunamadı.");
      return;
    }
    setIsLoading(true);
    try {
      const rows = await exportFinalCarPlatesToExcel(activeProduct.id);
      if (!rows || rows.length === 0) {
        toast.info("Plaka girmiş finalist bulunamadı.");
      } else {
        toast.success(`${rows.length} plaka Excel'e aktarıldı.`);
      }
    } catch (err) {
      toast.error("Excel oluşturulurken hata oluştu: " + err.message);
    }
    setIsLoading(false);
  };

  const handleUpload = async () => {
    if (!activeProduct?.id) {
      toast.error("Aktif ürün bulunamadı.");
      return;
    }
    if (parsedRows.length === 0) {
      toast.error("Yüklenecek geçerli satır bulunamadı.");
      return;
    }
    setIsLoading(true);
    try {
      const res = await adminBulkUpdateYfSonuc(activeProduct.id, parsedRows);
      if (res.error) {
        toast.error(res.error);
      } else {
        setResultSummary(res);
        toast.success(res.result);
      }
    } catch (err) {
      toast.error("Güncelleme sırasında hata oluştu: " + err.message);
    }
    setIsLoading(false);
  };

  if (user?.role !== "admin") {
    return (
      <div>
        <h3>Yetkisiz Erişim</h3>
        <p>Bu sayfaya erişim izniniz bulunmamaktadır.</p>
      </div>
    );
  }

  const hasFile = !!fileName;

  return (
    <div>
      <div
        style={{
          maxWidth: 820,
          border: "1px solid #e3d9ee",
          borderRadius: 12,
          padding: "24px 28px",
          marginTop: 10,
          marginBottom: 24,
          background: "#fff",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <h3 style={{ margin: 0, color: "#582b71" }}>
            Final Aşamasına Kalanlar
          </h3>
          <Chip
            size="small"
            label={activeProduct?.id || "aktif ürün yok"}
            style={{
              backgroundColor: "#582b71",
              color: "#fff",
              fontWeight: 600,
            }}
          />
        </div>
        <p style={{ color: "#555", fontSize: 14, lineHeight: 1.6 }}>
          Yarı Final sonucu <strong>başarılı (1)</strong> olan, yani Final
          aşamasına hak kazanan kullanıcıların{" "}
          <strong>UID, Ad-Soyad, Email ve Kategori</strong> bilgilerini Excel
          olarak indirir.
        </p>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<FileDownloadIcon />}
          disabled={isLoading || !activeProduct?.id}
          style={{ textTransform: "none", fontWeight: 600 }}
          onClick={handleExportFinalCandidates}
        >
          Final'e Kalanları İndir (Excel)
        </Button>
        <p
          style={{
            color: "#555",
            fontSize: 14,
            lineHeight: 1.6,
            marginTop: 20,
          }}
        >
          Final aşamasına hak kazanıp profilinde <strong>araç plakası</strong>{" "}
          giren kullanıcıların <strong>yalnızca plakalarını</strong> Excel
          olarak indirir.
        </p>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<FileDownloadIcon />}
          disabled={isLoading || !activeProduct?.id}
          style={{ textTransform: "none", fontWeight: 600 }}
          onClick={handleExportFinalCarPlates}
        >
          Finale Kalanların Plaka Listesini İndir (Excel)
        </Button>
      </div>

      <div
        style={{
          maxWidth: 820,
          border: "1px solid #e3d9ee",
          borderRadius: 12,
          padding: "24px 28px",
          marginTop: 10,
          background: "#fff",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <h3 style={{ margin: 0, color: "#582b71" }}>
            Yarı Final Sınavı Sonuçlarını Toplu Yükle
          </h3>
          <Chip
            size="small"
            label={activeProduct?.id || "aktif ürün yok"}
            style={{
              backgroundColor: "#582b71",
              color: "#fff",
              fontWeight: 600,
            }}
          />
        </div>
        <p style={{ color: "#555", fontSize: 14, lineHeight: 1.6 }}>
          Excel dosyasında <strong>user_id</strong> (kullanıcının uid'si) ve{" "}
          <strong>yf_sonuc</strong> (örn. 1 = başarılı, 2 = elendi) sütunları
          olmalıdır. Emin değilsen önce örnek dosyayı indirip formatı kontrol
          edebilirsin.
        </p>

        <Button
          variant="text"
          color="secondary"
          startIcon={<FileDownloadIcon />}
          style={{ textTransform: "none", paddingLeft: 0 }}
          onClick={handleDownloadSample}
        >
          Örnek Excel İndir
        </Button>

        <div
          style={{
            marginTop: 16,
            border: "2px dashed #c8b6dc",
            borderRadius: 10,
            padding: "24px 20px",
            textAlign: "center",
            background: "#faf7fc",
          }}
        >
          <input
            ref={fileInputRef}
            type="file"
            accept=".xlsx,.xls,.csv"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          {!hasFile ? (
            <>
              <CloudUploadIcon style={{ fontSize: 40, color: "#8a63a8" }} />
              <div
                style={{ margin: "8px 0 16px", color: "#555", fontSize: 14 }}
              >
                Yüklemek istediğin Excel/CSV dosyasını seç
              </div>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => fileInputRef.current?.click()}
                style={{ textTransform: "none", fontWeight: 600 }}
              >
                Dosya Seç
              </Button>
            </>
          ) : (
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                  fontWeight: 600,
                  color: "#333",
                }}
              >
                <InsertDriveFileIcon style={{ color: "#8a63a8" }} />
                {fileName}
              </div>
              <div
                style={{
                  marginTop: 10,
                  display: "flex",
                  justifyContent: "center",
                  gap: 8,
                  flexWrap: "wrap",
                }}
              >
                <Chip
                  size="small"
                  icon={<TaskAltIcon style={{ color: "#2e7d32 !important" }} />}
                  label={`${parsedRows.length} geçerli satır`}
                  style={{ backgroundColor: "#e6f4ea", color: "#2e7d32" }}
                />
                {invalidRowCount > 0 && (
                  <Chip
                    size="small"
                    icon={
                      <ErrorOutlineIcon
                        style={{ color: "#c66500 !important" }}
                      />
                    }
                    label={`${invalidRowCount} satır atlandı`}
                    style={{ backgroundColor: "#fdf0e0", color: "#c66500" }}
                  />
                )}
              </div>
              <Button
                variant="text"
                size="small"
                color="secondary"
                style={{ marginTop: 10, textTransform: "none" }}
                onClick={() => fileInputRef.current?.click()}
              >
                Başka dosya seç
              </Button>
            </div>
          )}
        </div>

        {isLoading && <LoadingBlock />}

        {parsedRows.length > 0 && (
          <>
            <TableContainer
              component={Paper}
              variant="outlined"
              style={{ marginTop: 20, maxHeight: 320 }}
            >
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: "bold" }}>
                      Kullanıcı ID
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>
                      Yarı Final Sonucu
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {parsedRows.slice(0, 50).map((r, i) => (
                    <TableRow
                      key={r.uid + i}
                      hover
                      style={{
                        backgroundColor: i % 2 === 0 ? "#fff" : "#faf8fc",
                      }}
                    >
                      <TableCell style={{ fontFamily: "monospace" }}>
                        {r.uid}
                      </TableCell>
                      <TableCell>
                        <Chip
                          size="small"
                          label={r.yf_sonuc}
                          style={{
                            backgroundColor:
                              r.yf_sonuc === 1 ? "#e6f4ea" : "#f0e6f7",
                            color: r.yf_sonuc === 1 ? "#2e7d32" : "#582b71",
                            fontWeight: 600,
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            {parsedRows.length > 50 && (
              <div style={{ marginTop: 6, fontSize: 12, color: "#777" }}>
                Önizlemede ilk 50 satır gösteriliyor, toplam {parsedRows.length}{" "}
                satır güncellenecek.
              </div>
            )}
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              style={{
                marginTop: 18,
                padding: "10px 0",
                fontWeight: 700,
                textTransform: "none",
              }}
              disabled={isLoading}
              onClick={handleUpload}
            >
              {parsedRows.length} Kullanıcıyı Güncelle
            </Button>
          </>
        )}

        {resultSummary && (
          <div
            style={{
              marginTop: 20,
              padding: "16px 18px",
              background: "#f5f0f9",
              border: "1px solid #e3d9ee",
              borderRadius: 10,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                fontWeight: 700,
                color: "#2e7d32",
              }}
            >
              <TaskAltIcon />
              {resultSummary.updated} kullanıcı güncellendi
            </div>
            {resultSummary.invalidCount > 0 && (
              <div style={{ marginTop: 6, fontSize: 13, color: "#c66500" }}>
                {resultSummary.invalidCount} satır geçersiz olduğu için atlandı.
              </div>
            )}
            {resultSummary.notFound?.length > 0 && (
              <div style={{ marginTop: 6, fontSize: 13, color: "#b3261e" }}>
                Bulunamayan kullanıcı id'leri ({resultSummary.notFound.length}):{" "}
                <span style={{ fontFamily: "monospace" }}>
                  {resultSummary.notFound.join(", ")}
                </span>
              </div>
            )}
          </div>
        )}
        <ToastContainer />
      </div>
    </div>
  );
};

const BulkExamRoomInfoBox = () => {
  const { user } = React.useContext(AppContext);
  const [activeProduct, setActiveProduct] = useState(null);
  const [fileName, setFileName] = useState("");
  const [parsedRows, setParsedRows] = useState([]);
  const [invalidRowCount, setInvalidRowCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [resultSummary, setResultSummary] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    const getProduct = async () => {
      const product = await fetchActiveProduct("admin");
      setActiveProduct(product);
    };
    getProduct();
  }, []);

  const findColumnValue = (row, candidates) => {
    const keys = Object.keys(row);
    for (const candidate of candidates) {
      const foundKey = keys.find((k) => k.trim().toLowerCase() === candidate);
      if (foundKey !== undefined) return row[foundKey];
    }
    return undefined;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setFileName(file.name);
    setResultSummary(null);
    const reader = new FileReader();
    reader.onload = (evt) => {
      const data = new Uint8Array(evt.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(sheet, { defval: "" });

      const rows = [];
      let invalid = 0;
      json.forEach((row) => {
        const uid = findColumnValue(row, [
          "user_id",
          "uid",
          "kullanıcı_id",
          "kullanici_id",
        ]);
        const examRoomInfoRaw = findColumnValue(row, [
          "exam_room_info",
          "salon_bilgisi",
          "sinav_salon_bilgisi",
          "salon",
        ]);
        const exam_room_info = (examRoomInfoRaw || "").toString().trim();
        if (!uid || !exam_room_info) {
          invalid++;
          return;
        }
        rows.push({ uid: uid.toString().trim(), exam_room_info });
      });
      setParsedRows(rows);
      setInvalidRowCount(invalid);
    };
    reader.readAsArrayBuffer(file);
  };

  const handleDownloadSample = () => {
    const sampleData = [
      {
        user_id: "Ab12Cd34Ef56Gh78Ij90KlMnOpQr",
        exam_room_info: "205 Nolu Salon",
      },
      {
        user_id: "Zy98Xw76Vu54Ts32Rq10PoNmLkJi",
        exam_room_info: "112 Nolu Salon",
      },
    ];
    const worksheet = XLSX.utils.json_to_sheet(sampleData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sinav Salon Bilgileri");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "sinav_salon_bilgileri_ornek.xlsx";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const handleExportExamRoomUsers = async () => {
    if (!activeProduct?.id) {
      toast.error("Aktif ürün bulunamadı.");
      return;
    }
    setIsLoading(true);
    try {
      const examAccessIds = activeProduct?.exams?.[0]?.exam_access_ids;
      const rows = await exportExamRoomUsersToExcel(
        activeProduct.id,
        examAccessIds
      );
      if (!rows || rows.length === 0) {
        toast.info("Salon bilgisi kayıtlı kullanıcı bulunamadı.");
      } else {
        toast.success(`${rows.length} kullanıcı Excel'e aktarıldı.`);
      }
    } catch (err) {
      toast.error("Excel oluşturulurken hata oluştu: " + err.message);
    }
    setIsLoading(false);
  };

  const handleUpload = async () => {
    if (!activeProduct?.id) {
      toast.error("Aktif ürün bulunamadı.");
      return;
    }
    if (parsedRows.length === 0) {
      toast.error("Yüklenecek geçerli satır bulunamadı.");
      return;
    }
    setIsLoading(true);
    try {
      const res = await adminBulkUpdateExamRoomInfo(
        activeProduct.id,
        parsedRows
      );
      if (res.error) {
        toast.error(res.error);
      } else {
        setResultSummary(res);
        toast.success(res.result);
      }
    } catch (err) {
      toast.error("Güncelleme sırasında hata oluştu: " + err.message);
    }
    setIsLoading(false);
  };

  if (user?.role !== "admin") {
    return (
      <div>
        <h3>Yetkisiz Erişim</h3>
        <p>Bu sayfaya erişim izniniz bulunmamaktadır.</p>
      </div>
    );
  }

  const hasFile = !!fileName;

  return (
    <div>
      <div
        style={{
          maxWidth: 820,
          border: "1px solid #e3d9ee",
          borderRadius: 12,
          padding: "24px 28px",
          marginTop: 10,
          marginBottom: 24,
          background: "#fff",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <h3 style={{ margin: 0, color: "#582b71" }}>Final - Salon Listesi</h3>
          <Chip
            size="small"
            label={activeProduct?.id || "aktif ürün yok"}
            style={{
              backgroundColor: "#582b71",
              color: "#fff",
              fontWeight: 600,
            }}
          />
        </div>
        <p style={{ color: "#555", fontSize: 14, lineHeight: 1.6 }}>
          Sınav salon bilgisi kayıtlı olan kullanıcıların{" "}
          <strong>Salon, Ad-Soyad, Email, Telefon ve Kategori</strong>{" "}
          bilgilerini Excel olarak indirir. Liste salonlara göre, her salon
          kendi içinde ada göre (A-Z) sıralıdır.
        </p>
        <Button
          variant="contained"
          color="secondary"
          startIcon={<FileDownloadIcon />}
          disabled={isLoading || !activeProduct?.id}
          style={{ textTransform: "none", fontWeight: 600 }}
          onClick={handleExportExamRoomUsers}
        >
          Final - Salon Listesini İndir (Excel)
        </Button>
      </div>

      <div
        style={{
          maxWidth: 820,
          border: "1px solid #e3d9ee",
          borderRadius: 12,
          padding: "24px 28px",
          marginTop: 10,
          background: "#fff",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <h3 style={{ margin: 0, color: "#582b71" }}>
            Kişiye Özel Sınav Salon Bilgilerini Toplu Yükle
          </h3>
          <Chip
            size="small"
            label={activeProduct?.id || "aktif ürün yok"}
            style={{
              backgroundColor: "#582b71",
              color: "#fff",
              fontWeight: 600,
            }}
          />
        </div>
        <p style={{ color: "#555", fontSize: 14, lineHeight: 1.6 }}>
          Excel dosyasında <strong>user_id</strong> (kullanıcının uid'si) ve{" "}
          <strong>exam_room_info</strong> (sadece salon, örn. "205 Nolu Salon")
          sütunları olmalıdır. Emin değilsen önce örnek dosyayı indirip formatı
          kontrol edebilirsin. Bu bilgi, her kullanıcının kendi profil
          sayfasında sadece kendisine gösterilecektir.
        </p>

        <Button
          variant="text"
          color="secondary"
          startIcon={<FileDownloadIcon />}
          style={{ textTransform: "none", paddingLeft: 0 }}
          onClick={handleDownloadSample}
        >
          Örnek Excel İndir
        </Button>

        <div
          style={{
            marginTop: 16,
            border: "2px dashed #c8b6dc",
            borderRadius: 10,
            padding: "24px 20px",
            textAlign: "center",
            background: "#faf7fc",
          }}
        >
          <input
            ref={fileInputRef}
            type="file"
            accept=".xlsx,.xls,.csv"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          {!hasFile ? (
            <>
              <CloudUploadIcon style={{ fontSize: 40, color: "#8a63a8" }} />
              <div
                style={{ margin: "8px 0 16px", color: "#555", fontSize: 14 }}
              >
                Yüklemek istediğin Excel/CSV dosyasını seç
              </div>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => fileInputRef.current?.click()}
                style={{ textTransform: "none", fontWeight: 600 }}
              >
                Dosya Seç
              </Button>
            </>
          ) : (
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                  fontWeight: 600,
                  color: "#333",
                }}
              >
                <InsertDriveFileIcon style={{ color: "#8a63a8" }} />
                {fileName}
              </div>
              <div
                style={{
                  marginTop: 10,
                  display: "flex",
                  justifyContent: "center",
                  gap: 8,
                  flexWrap: "wrap",
                }}
              >
                <Chip
                  size="small"
                  icon={<TaskAltIcon style={{ color: "#2e7d32 !important" }} />}
                  label={`${parsedRows.length} geçerli satır`}
                  style={{ backgroundColor: "#e6f4ea", color: "#2e7d32" }}
                />
                {invalidRowCount > 0 && (
                  <Chip
                    size="small"
                    icon={
                      <ErrorOutlineIcon
                        style={{ color: "#c66500 !important" }}
                      />
                    }
                    label={`${invalidRowCount} satır atlandı`}
                    style={{ backgroundColor: "#fdf0e0", color: "#c66500" }}
                  />
                )}
              </div>
              <Button
                variant="text"
                size="small"
                color="secondary"
                style={{ marginTop: 10, textTransform: "none" }}
                onClick={() => fileInputRef.current?.click()}
              >
                Başka dosya seç
              </Button>
            </div>
          )}
        </div>

        {isLoading && <LoadingBlock />}

        {parsedRows.length > 0 && (
          <>
            <TableContainer
              component={Paper}
              variant="outlined"
              style={{ marginTop: 20, maxHeight: 320 }}
            >
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: "bold" }}>
                      Kullanıcı ID
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>
                      Sınav Salon Bilgisi
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {parsedRows.slice(0, 50).map((r, i) => (
                    <TableRow
                      key={r.uid + i}
                      hover
                      style={{
                        backgroundColor: i % 2 === 0 ? "#fff" : "#faf8fc",
                      }}
                    >
                      <TableCell style={{ fontFamily: "monospace" }}>
                        {r.uid}
                      </TableCell>
                      <TableCell>{r.exam_room_info}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            {parsedRows.length > 50 && (
              <div style={{ marginTop: 6, fontSize: 12, color: "#777" }}>
                Önizlemede ilk 50 satır gösteriliyor, toplam {parsedRows.length}{" "}
                satır güncellenecek.
              </div>
            )}
            <Button
              variant="contained"
              color="secondary"
              fullWidth
              style={{
                marginTop: 18,
                padding: "10px 0",
                fontWeight: 700,
                textTransform: "none",
              }}
              disabled={isLoading}
              onClick={handleUpload}
            >
              {parsedRows.length} Kullanıcıyı Güncelle
            </Button>
          </>
        )}

        {resultSummary && (
          <div
            style={{
              marginTop: 20,
              padding: "16px 18px",
              background: "#f5f0f9",
              border: "1px solid #e3d9ee",
              borderRadius: 10,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                fontWeight: 700,
                color: "#2e7d32",
              }}
            >
              <TaskAltIcon />
              {resultSummary.updated} kullanıcı güncellendi
            </div>
            {resultSummary.invalidCount > 0 && (
              <div style={{ marginTop: 6, fontSize: 13, color: "#c66500" }}>
                {resultSummary.invalidCount} satır geçersiz olduğu için atlandı.
              </div>
            )}
            {resultSummary.notFound?.length > 0 && (
              <div style={{ marginTop: 6, fontSize: 13, color: "#b3261e" }}>
                Bulunamayan kullanıcı id'leri ({resultSummary.notFound.length}):{" "}
                <span style={{ fontFamily: "monospace" }}>
                  {resultSummary.notFound.join(", ")}
                </span>
              </div>
            )}
          </div>
        )}
        <ToastContainer />
      </div>
    </div>
  );
};

const ExamLinksBox = () => {
  const { user } = React.useContext(AppContext);
  const [activeProduct, setActiveProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const getProduct = async () => {
      const product = await fetchActiveProduct("admin");
      setActiveProduct(product);
    };
    getProduct();
  }, []);

  const handleExportExamLinks = async () => {
    if (!activeProduct?.id) {
      toast.error("Aktif ürün bulunamadı.");
      return;
    }
    setIsLoading(true);
    try {
      const rows = await exportExamLinksToExcel(
        activeProduct.id,
        activeProduct.exams
      );
      if (!rows || rows.length === 0) {
        toast.info("Final aşamasına hak kazanan kullanıcı bulunamadı.");
      } else {
        toast.success(`${rows.length} kullanıcı Excel'e aktarıldı.`);
      }
    } catch (err) {
      toast.error("Excel oluşturulurken hata oluştu: " + err.message);
    }
    setIsLoading(false);
  };

  if (user?.role !== "admin") {
    return (
      <div>
        <h3>Yetkisiz Erişim</h3>
        <p>Bu sayfaya erişim izniniz bulunmamaktadır.</p>
      </div>
    );
  }

  return (
    <div
      style={{
        maxWidth: 820,
        border: "1px solid #e3d9ee",
        borderRadius: 12,
        padding: "24px 28px",
        marginTop: 10,
        marginBottom: 24,
        background: "#fff",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <h3 style={{ margin: 0, color: "#582b71" }}>Sınav Linkleri</h3>
        <Chip
          size="small"
          label={activeProduct?.id || "aktif ürün yok"}
          style={{
            backgroundColor: "#582b71",
            color: "#fff",
            fontWeight: 600,
          }}
        />
      </div>
      <p style={{ color: "#555", fontSize: 14, lineHeight: 1.6 }}>
        Final aşamasına hak kazanan (Yarı Final sonucu{" "}
        <strong>başarılı (1)</strong> olan) kullanıcıların{" "}
        <strong>Salon, Ad-Soyad, Kategori ve Final Sınav Linki</strong>{" "}
        bilgilerini Excel olarak indirir. İlk sayfada tüm liste, ardından her
        salon/sınıf için ayrı bir sayfa (sheet) bulunur; salon içinde liste ada
        göre (A-Z) sıralıdır.
      </p>
      <Button
        variant="contained"
        color="secondary"
        startIcon={<FileDownloadIcon />}
        disabled={isLoading || !activeProduct?.id}
        style={{ textTransform: "none", fontWeight: 600 }}
        onClick={handleExportExamLinks}
      >
        Sınav Linklerini İndir (Excel)
      </Button>
    </div>
  );
};

// Eşit puanlar aynı sırayı alır, sonraki sıra atlanmaz (100, 90, 90, 80 → 1, 2, 2, 3).
// Aynı sıradakiler kendi aralarında ada göre alfabetik dizilir.
const rankByScore = (rows) => {
  const sorted = [...rows].sort(
    (a, b) =>
      b.final_puan - a.final_puan ||
      (a.name || "").localeCompare(b.name || "", "tr")
  );
  let rank = 0;
  return sorted.map((r, i) => {
    if (i === 0 || sorted[i - 1].final_puan !== r.final_puan) rank++;
    return { ...r, rank };
  });
};

const parseScore = (raw) => Number(raw.toString().trim().replace(",", "."));

const FinalScoresBox = () => {
  const { user } = React.useContext(AppContext);
  const [activeProduct, setActiveProduct] = useState(null);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [uidInput, setUidInput] = useState("");
  const [scoreInput, setScoreInput] = useState("");
  const [previewUser, setPreviewUser] = useState(null);
  const [fileName, setFileName] = useState("");
  const [parsedRows, setParsedRows] = useState([]);
  const [invalidRowCount, setInvalidRowCount] = useState(0);
  const fileInputRef = useRef(null);
  const [selectedCategory, setSelectedCategory] = useState("__all__");
  const [odulEmailsInput, setOdulEmailsInput] = useState("");

  const examAccessIds =
    activeProduct?.exams?.[2]?.exam_access_ids ||
    activeProduct?.exams?.[0]?.exam_access_ids;

  const loadRows = useCallback(async (productId) => {
    setIsLoading(true);
    try {
      setRows(await getFinalPuanUsers(productId));
    } catch (err) {
      toast.error("Puanlar yüklenemedi: " + err.message);
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    const getProduct = async () => {
      const product = await fetchActiveProduct("admin");
      setActiveProduct(product);
      if (product?.id) loadRows(product.id);
    };
    getProduct();
  }, [loadRows]);

  const lookupUid = async () => {
    const uid = uidInput.trim();
    if (!uid) {
      setPreviewUser(null);
      return;
    }
    const u = await pullUserData(uid);
    setPreviewUser(u ? { ...u, uid } : { uid, notFound: true });
  };

  const save = async (payload) => {
    if (!activeProduct?.id) {
      toast.error("Aktif ürün bulunamadı.");
      return false;
    }
    setIsLoading(true);
    let ok = false;
    try {
      const res = await adminSetFinalPuan(activeProduct.id, payload);
      if (res.error) {
        toast.error(res.error);
      } else {
        toast.success(res.result);
        if (res.notFound?.length > 0)
          toast.error("Bulunamayan uid'ler: " + res.notFound.join(", "));
        if (res.invalidCount > 0)
          toast.warn(`${res.invalidCount} satır geçersiz olduğu için atlandı.`);
        ok = true;
      }
    } catch (err) {
      toast.error("Kaydedilirken hata oluştu: " + err.message);
    }
    setIsLoading(false);
    await loadRows(activeProduct.id);
    return ok;
  };

  const handleAdd = async () => {
    const uid = uidInput.trim();
    const final_puan = parseScore(scoreInput);
    if (!uid || scoreInput.trim() === "" || !Number.isFinite(final_puan)) {
      toast.error("Geçerli bir UID ve puan girin.");
      return;
    }
    if (await save([{ uid, final_puan }])) {
      setUidInput("");
      setScoreInput("");
      setPreviewUser(null);
    }
  };

  // Excel'de user_id (veya uid) ve puan (veya final_puan) sütunları beklenir
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    e.target.value = "";
    if (!file) return;
    setFileName(file.name);
    const reader = new FileReader();
    reader.onload = (evt) => {
      const workbook = XLSX.read(new Uint8Array(evt.target.result), {
        type: "array",
      });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const json = XLSX.utils.sheet_to_json(sheet, { defval: "" });
      const pick = (row, candidates) => {
        const key = Object.keys(row).find((k) =>
          candidates.includes(k.trim().toLocaleLowerCase("tr"))
        );
        return key === undefined ? undefined : row[key];
      };
      const parsed = [];
      let invalid = 0;
      json.forEach((row) => {
        const uid = (pick(row, ["user_id", "uid", "kullanıcı_id"]) || "")
          .toString()
          .trim();
        const raw = pick(row, ["puan", "final_puan", "score"]);
        const final_puan =
          raw === undefined || raw === "" ? NaN : parseScore(raw);
        if (!uid || !Number.isFinite(final_puan)) invalid++;
        else parsed.push({ uid, final_puan });
      });
      setParsedRows(parsed);
      setInvalidRowCount(invalid);
    };
    reader.readAsArrayBuffer(file);
  };

  const handleDownloadSample = () => {
    const ws = XLSX.utils.json_to_sheet([
      { user_id: "Ab12Cd34Ef56Gh78Ij90KlMnOpQr", puan: 87.5 },
      { user_id: "Zy98Xw76Vu54Ts32Rq10PoNmLkJi", puan: 64 },
    ]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Final Puanlari");
    XLSX.writeFile(wb, "final_puanlari_ornek.xlsx");
  };

  const handleUpload = async () => {
    if (await save(parsedRows)) {
      setFileName("");
      setParsedRows([]);
      setInvalidRowCount(0);
    }
  };

  const handleDelete = async (r) => {
    if (
      !window.confirm(`${r.name || r.uid} kişisinin final puanı silinsin mi?`)
    )
      return;
    await save([{ uid: r.uid, final_puan: null }]);
  };

  const rowsWithCategory = rows.map((r) => ({
    ...r,
    category: getCategoryForBirthYear(r.birth_year, examAccessIds) || "-",
  }));

  const categories = [
    ...new Set([
      ...(examAccessIds || []).map((a) => a.category).filter(Boolean),
      ...rowsWithCategory.map((r) => r.category),
    ]),
  ];

  const rankedRows = rankByScore(
    selectedCategory === "__all__"
      ? rowsWithCategory
      : rowsWithCategory.filter((r) => r.category === selectedCategory)
  );

  // Her kategori kendi içinde sıralanır; Şeref Kürsüsü bu dereceyi kullanır
  const categoryRankByUid = new Map();
  categories.forEach((c) =>
    rankByScore(rowsWithCategory.filter((r) => r.category === c)).forEach((r) =>
      categoryRankByUid.set(r.uid, r.rank)
    )
  );
  const uncategorized = rowsWithCategory.filter((r) => r.category === "-");
  const unsavedCount = rowsWithCategory.filter(
    (r) =>
      r.category !== "-" && r.final_derecesi !== categoryRankByUid.get(r.uid)
  ).length;

  const handleClearRanks = async () => {
    if (!activeProduct?.id) {
      toast.error("Aktif ürün bulunamadı.");
      return;
    }
    setIsLoading(true);
    let hofUsers = [];
    try {
      hofUsers = await getHallOfFameUsers(activeProduct.id);
    } catch (err) {
      toast.error("Şeref Kürsüsü kayıtları okunamadı: " + err.message);
      setIsLoading(false);
      return;
    }
    setIsLoading(false);
    const filledCount = hofUsers.filter((u) => u.about || u.photo).length;
    if (
      !window.confirm(
        `${activeProduct.id} Şeref Kürsüsü kaldırılacak: ${hofUsers.length} kayıt silinecek ve tüm kayıtlı final dereceleri temizlenecek.` +
          (filledCount > 0
            ? `\n\nDİKKAT: ${filledCount} kişinin yüklediği özgeçmiş/fotoğraf bilgisi de silinecek ve geri alınamaz.`
            : "") +
          "\n\nDevam edilsin mi?"
      )
    )
      return;
    setIsLoading(true);
    try {
      const res = await adminClearFinalRanks(activeProduct.id);
      if (res.error) toast.error(res.error);
      else toast.success(res.result);
    } catch (err) {
      toast.error("Şeref Kürsüsü kaldırılırken hata oluştu: " + err.message);
    }
    setIsLoading(false);
    await loadRows(activeProduct.id);
  };

  // Ödül işareti yalnızca kayıtlı derecesi ilk 5'te olanlara verilebilir
  const handleToggleOdul = async (r) => {
    const next = !r.odul_gonderilecek;
    if (
      !window.confirm(
        next
          ? `${r.name} için ödül gönderimi tanımlansın mı? Profilinde kargo adresi formu açılacak.`
          : `${r.name} için ödül gönderimi kaldırılsın mı? Kargo adresi formu kapanacak.`
      )
    )
      return;
    setIsLoading(true);
    try {
      const res = await adminSetOdulGonderimi(activeProduct.id, [
        { uid: r.uid, odul_gonderilecek: next },
      ]);
      if (res.error) toast.error(res.error);
      else toast.success(res.result);
    } catch (err) {
      toast.error("Ödül durumu kaydedilirken hata oluştu: " + err.message);
    }
    setIsLoading(false);
    await loadRows(activeProduct.id);
  };

  // Yapıştırılan e-posta listesindeki kişilere toplu ödül tanımlar.
  // E-postalar final puanı girilmiş kullanıcılar (rows) içinde aranır.
  const handleBulkOdul = async () => {
    const emails = [
      ...new Set(
        odulEmailsInput
          .split(/[\s,;]+/)
          .map((e) => e.trim().toLocaleLowerCase("tr"))
          .filter(Boolean)
      ),
    ];
    if (emails.length === 0) {
      toast.error("En az bir e-posta adresi girin.");
      return;
    }
    const byEmail = new Map(
      rows
        .filter((r) => r.email)
        .map((r) => [r.email.trim().toLocaleLowerCase("tr"), r])
    );
    const matched = emails.map((e) => byEmail.get(e)).filter(Boolean);
    const unmatched = emails.filter((e) => !byEmail.has(e));
    const outsideTop5 = matched.filter(
      (r) => !(r.final_derecesi >= 1 && r.final_derecesi <= 5)
    );
    if (matched.length === 0) {
      toast.error(
        "Listedeki e-postaların hiçbiri final sıralamasında bulunamadı."
      );
      return;
    }
    if (
      !window.confirm(
        `${matched.length} kişiye ödül gönderimi tanımlanacak ve profillerinde kargo adresi formu açılacak.` +
          (unmatched.length > 0
            ? `\n\nBulunamayan ${
                unmatched.length
              } e-posta atlanacak:\n${unmatched.join("\n")}`
            : "") +
          (outsideTop5.length > 0
            ? `\n\nDİKKAT: ${
                outsideTop5.length
              } kişinin kayıtlı derecesi ilk 5'te değil, form onlara açılmaz:\n${outsideTop5
                .map((r) => r.email)
                .join("\n")}`
            : "") +
          "\n\nDevam edilsin mi?"
      )
    )
      return;
    setIsLoading(true);
    try {
      const res = await adminSetOdulGonderimi(
        activeProduct.id,
        matched.map((r) => ({ uid: r.uid, odul_gonderilecek: true }))
      );
      if (res.error) {
        toast.error(res.error);
      } else {
        toast.success(res.result);
        if (unmatched.length > 0)
          toast.warn("Bulunamayan e-postalar: " + unmatched.join(", "));
        setOdulEmailsInput("");
      }
    } catch (err) {
      toast.error("Ödül durumu kaydedilirken hata oluştu: " + err.message);
    }
    setIsLoading(false);
    await loadRows(activeProduct.id);
  };

  const handleSaveRanks = async () => {
    if (!activeProduct?.id) {
      toast.error("Aktif ürün bulunamadı.");
      return;
    }
    const payload = rowsWithCategory
      .filter((r) => r.category !== "-")
      .map((r) => ({
        uid: r.uid,
        final_derecesi: categoryRankByUid.get(r.uid),
        category: r.category,
      }));
    if (payload.length === 0) return;
    if (
      !window.confirm(
        `${payload.length} kişinin kategori derecesi kaydedilecek ve her kategorinin ilk 10'u Şeref Kürsüsü'nde yayınlanacak. Devam edilsin mi?`
      )
    )
      return;
    setIsLoading(true);
    try {
      const res = await adminSaveFinalRanks(activeProduct.id, payload);
      if (res.error) {
        toast.error(res.error);
      } else {
        toast.success(res.result);
        if (res.notFound?.length > 0)
          toast.error("Bulunamayan uid'ler: " + res.notFound.join(", "));
        if (res.hofRemoved > 0)
          toast.warn(
            `${res.hofRemoved} kişi artık ilk 10'da olmadığı için Şeref Kürsüsü'nden kaldırıldı.`
          );
      }
    } catch (err) {
      toast.error("Sıralama kaydedilirken hata oluştu: " + err.message);
    }
    setIsLoading(false);
    await loadRows(activeProduct.id);
  };

  // Kayıtlı (Şeref Kürsüsü'ne yansımış) dereceye göre ilk N listesi
  const handleExportTop = (limit) => {
    const top = rowsWithCategory
      .filter((r) => r.final_derecesi >= 1 && r.final_derecesi <= limit)
      .sort(
        (a, b) =>
          a.category.localeCompare(b.category, "tr") ||
          a.final_derecesi - b.final_derecesi ||
          (a.name || "").localeCompare(b.name || "", "tr")
      );
    if (top.length === 0) {
      toast.error("Kayıtlı derece bulunamadı. Önce sıralamaları kaydedin.");
      return;
    }
    const data = top.map((r) => {
      const row = {
        KATEGORİ: r.category,
        DERECE: r.final_derecesi,
        USER_ID: r.uid,
        "ADI-SOYADI": r.name,
        EPOSTA: r.email,
        TELEFON: r.phone || "",
        PUAN: r.final_puan,
      };
      if (limit <= 5) {
        const k = r.kargo_adresi;
        Object.assign(row, {
          "ÖDÜL GÖNDERİLECEK": r.odul_gonderilecek ? "Evet" : "Hayır",
          "KARGO ALICI": k?.alici || "",
          "KARGO TELEFON": k?.telefon || "",
          "AÇIK ADRES": k ? formatShippingAddress(k) : "",
          İLÇE: k?.ilce || "",
          İL: k?.il || "",
          "POSTA KODU": k?.posta_kodu || "",
          "ADRES DURUMU": k ? "Girildi" : "GİRİLMEDİ",
          "TESLİM DURUMU": r.kargo_teslim_alindi
            ? "Teslim alındı"
            : "Teslim alınmadı",
        });
      }
      return row;
    });
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, `Ilk ${limit}`);
    XLSX.writeFile(wb, `Final Ilk ${limit} - ${activeProduct?.id}.xlsx`);
  };

  const handleExport = () => {
    const data = rankedRows.map((r) => ({
      SIRA: r.rank,
      UID: r.uid,
      "ADI-SOYADI": r.name,
      EPOSTA: r.email,
      "DOĞUM YILI": r.birth_year || "",
      KATEGORİ: r.category,
      PUAN: r.final_puan,
      "KATEGORİ DERECESİ": categoryRankByUid.get(r.uid) || "",
    }));
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Final Siralama");
    const label = selectedCategory === "__all__" ? "Genel" : selectedCategory;
    XLSX.writeFile(wb, `Final Siralama - ${label}.xlsx`);
  };

  if (user?.role !== "admin") {
    return (
      <div>
        <h3>Yetkisiz Erişim</h3>
        <p>Bu sayfaya erişim izniniz bulunmamaktadır.</p>
      </div>
    );
  }

  const boxStyle = {
    maxWidth: 1000,
    border: "1px solid #e3d9ee",
    borderRadius: 12,
    padding: "24px 28px",
    marginTop: 10,
    marginBottom: 24,
    background: "#fff",
  };

  return (
    <div>
      <div style={boxStyle}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <h3 style={{ margin: 0, color: "#582b71" }}>Final Puanı Ekle</h3>
          <Chip
            size="small"
            label={activeProduct?.id || "aktif ürün yok"}
            style={{
              backgroundColor: "#582b71",
              color: "#fff",
              fontWeight: 600,
            }}
          />
        </div>
        <p style={{ color: "#555", fontSize: 14, lineHeight: 1.6 }}>
          Kullanıcının <strong>UID</strong>'sini ve <strong>puanını</strong>{" "}
          gir. Ad-soyad, e-posta ve kategori otomatik getirilir. Aynı UID tekrar
          girilirse puanı güncellenir.
        </p>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <TextField
            label="UID"
            size="small"
            value={uidInput}
            onChange={(e) => {
              setUidInput(e.target.value);
              setPreviewUser(null);
            }}
            onBlur={lookupUid}
            style={{ width: 340 }}
            autoComplete="off"
          />
          <TextField
            label="Puan"
            size="small"
            value={scoreInput}
            onChange={(e) => setScoreInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && handleAdd()}
            style={{ width: 120 }}
            autoComplete="off"
          />
          <Button
            variant="contained"
            color="secondary"
            disabled={isLoading || !activeProduct?.id}
            style={{ textTransform: "none", fontWeight: 600 }}
            onClick={handleAdd}
          >
            Kaydet
          </Button>
        </div>
        {previewUser && (
          <div style={{ marginTop: 10, fontSize: 14 }}>
            {previewUser.notFound ? (
              <span style={{ color: "#b3261e" }}>
                Bu UID ile kullanıcı bulunamadı.
              </span>
            ) : (
              <span style={{ color: "#333" }}>
                <strong>{previewUser.name}</strong> — {previewUser.email} —{" "}
                {getCategoryForBirthYear(previewUser.birth_year, examAccessIds)}
                {previewUser.products?.[activeProduct?.id]?.yf_sonuc !== 1 && (
                  <span style={{ color: "#c66500" }}>
                    {" "}
                    (Yarı Final sonucu başarılı değil!)
                  </span>
                )}
              </span>
            )}
          </div>
        )}

        <div
          style={{
            marginTop: 20,
            border: "2px dashed #c8b6dc",
            borderRadius: 10,
            padding: "20px",
            textAlign: "center",
            background: "#faf7fc",
          }}
        >
          <input
            ref={fileInputRef}
            type="file"
            accept=".xlsx,.xls,.csv"
            onChange={handleFileChange}
            style={{ display: "none" }}
          />
          <div style={{ marginBottom: 12, color: "#555", fontSize: 14 }}>
            Excel'de <strong>user_id</strong> ve <strong>puan</strong> sütunları
            olmalı. Aynı kişi daha önce eklendiyse puanı güncellenir.
          </div>
          {fileName && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 8,
                flexWrap: "wrap",
                marginBottom: 12,
              }}
            >
              <InsertDriveFileIcon style={{ color: "#8a63a8" }} />
              <strong>{fileName}</strong>
              <Chip
                size="small"
                label={`${parsedRows.length} geçerli satır`}
                style={{ backgroundColor: "#e6f4ea", color: "#2e7d32" }}
              />
              {invalidRowCount > 0 && (
                <Chip
                  size="small"
                  label={`${invalidRowCount} satır atlandı`}
                  style={{ backgroundColor: "#fdf0e0", color: "#c66500" }}
                />
              )}
            </div>
          )}
          <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
            <Button
              variant="outlined"
              color="secondary"
              startIcon={<CloudUploadIcon />}
              style={{ textTransform: "none", fontWeight: 600 }}
              onClick={() => fileInputRef.current?.click()}
            >
              {fileName ? "Başka Dosya Seç" : "Excel Seç"}
            </Button>
            {parsedRows.length > 0 && (
              <Button
                variant="contained"
                color="secondary"
                disabled={isLoading || !activeProduct?.id}
                style={{ textTransform: "none", fontWeight: 600 }}
                onClick={handleUpload}
              >
                {parsedRows.length} Kişinin Puanını Kaydet
              </Button>
            )}
          </div>
          <Button
            variant="text"
            color="secondary"
            size="small"
            startIcon={<FileDownloadIcon />}
            style={{ textTransform: "none", marginTop: 8 }}
            onClick={handleDownloadSample}
          >
            Örnek Excel İndir
          </Button>
        </div>
      </div>

      <div style={boxStyle}>
        <h3 style={{ margin: 0, color: "#582b71" }}>Ödül Gönderimi Tanımla</h3>
        <p style={{ color: "#555", fontSize: 14, lineHeight: 1.6 }}>
          Ödül gönderilecek kişilerin <strong>e-posta adreslerini</strong>{" "}
          yapıştır (her satıra bir tane veya virgülle ayrılmış). Bu kişilerin
          profilinde kargo adresi formu açılır; ilk 5'teki diğer kişiler
          bilgilendirme notunu görür. Tek tek kaldırmak için aşağıdaki tablodaki
          "Ödül" kutusunu kullan.{" "}
          <strong>
            {rows.filter((r) => r.odul_gonderilecek).length} kişiye tanımlı.
          </strong>
        </p>
        <TextField
          label="E-posta adresleri"
          multiline
          minRows={4}
          fullWidth
          size="small"
          value={odulEmailsInput}
          onChange={(e) => setOdulEmailsInput(e.target.value)}
        />
        <Button
          variant="contained"
          color="secondary"
          disabled={isLoading || !activeProduct?.id || !odulEmailsInput.trim()}
          style={{ textTransform: "none", fontWeight: 600, marginTop: 10 }}
          onClick={handleBulkOdul}
        >
          Ödül Tanımla
        </Button>
      </div>

      <div style={boxStyle}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 10,
            flexWrap: "wrap",
          }}
        >
          <h3 style={{ margin: 0, color: "#582b71" }}>
            Anlık Final Sıralaması ({rankedRows.length} kişi)
          </h3>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <Button
              variant="text"
              color="secondary"
              startIcon={<FileDownloadIcon />}
              disabled={rankedRows.length === 0}
              style={{ textTransform: "none" }}
              onClick={handleExport}
            >
              Bu Sıralamayı İndir (Excel)
            </Button>
            <Button
              variant="contained"
              color="secondary"
              disabled={isLoading || rows.length === 0 || !activeProduct?.id}
              style={{ textTransform: "none", fontWeight: 600 }}
              onClick={handleSaveRanks}
            >
              Sıralamaları Kaydet ve Şeref Kürsüsünü Güncelle
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              startIcon={<FileDownloadIcon />}
              disabled={rows.length === 0}
              style={{ textTransform: "none" }}
              onClick={() => handleExportTop(10)}
            >
              İlk 10 E-postaları
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              startIcon={<FileDownloadIcon />}
              disabled={rows.length === 0}
              style={{ textTransform: "none" }}
              onClick={() => handleExportTop(5)}
            >
              İlk 5 E-posta + Kargo Adresleri
            </Button>
            <Button
              variant="outlined"
              color="error"
              disabled={isLoading || !activeProduct?.id}
              style={{ textTransform: "none", fontWeight: 600 }}
              onClick={handleClearRanks}
            >
              Şeref Kürsüsünü Kaldır
            </Button>
          </div>
        </div>
        <div style={{ marginTop: 8, fontSize: 13, color: "#555" }}>
          Dereceler her kategori kendi içinde hesaplanarak kaydedilir; her
          kategorinin ilk 10'u Şeref Kürsüsü'nde yayınlanır ve profillerinde
          özgeçmiş/fotoğraf yükleme alanı açılır.{" "}
          {unsavedCount > 0 ? (
            <strong style={{ color: "#c66500" }}>
              {unsavedCount} kişinin kayıtlı derecesi güncel sıralamadan farklı
              — kaydetmeyi unutmayın.
            </strong>
          ) : (
            rows.length > 0 && (
              <strong style={{ color: "#2e7d32" }}>
                Kayıtlı dereceler güncel.
              </strong>
            )
          )}
          {uncategorized.length > 0 && (
            <div style={{ color: "#b3261e", marginTop: 4 }}>
              {uncategorized.length} kişinin doğum yılından kategori
              bulunamadığı için derecesi kaydedilmeyecek.
            </div>
          )}
        </div>

        <RadioGroup
          row
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          <FormControlLabel
            value="__all__"
            control={<Radio color="secondary" />}
            label="Genel Sıralama"
          />
          {categories.map((c) => (
            <FormControlLabel
              key={c}
              value={c}
              control={<Radio color="secondary" />}
              label={c}
            />
          ))}
        </RadioGroup>

        {isLoading && <LoadingBlock />}

        <TableContainer
          component={Paper}
          variant="outlined"
          style={{ marginTop: 12, maxHeight: 600 }}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                {[
                  "Sıra",
                  "Ad-Soyad",
                  "E-posta",
                  "Kategori",
                  "Puan",
                  "Kat. Derecesi",
                  "Ödül",
                  "",
                ].map((h) => (
                  <TableCell key={h} style={{ fontWeight: "bold" }}>
                    {h}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rankedRows.map((r, i) => (
                <TableRow
                  key={r.uid}
                  hover
                  style={{
                    backgroundColor: i % 2 === 0 ? "#fff" : "#faf8fc",
                  }}
                >
                  <TableCell style={{ fontWeight: 700 }}>{r.rank}</TableCell>
                  <TableCell>
                    {r.name}
                    {r.yf_sonuc !== 1 && (
                      <Chip
                        size="small"
                        label="YF başarılı değil"
                        style={{
                          marginLeft: 6,
                          backgroundColor: "#fdf0e0",
                          color: "#c66500",
                        }}
                      />
                    )}
                  </TableCell>
                  <TableCell>{r.email}</TableCell>
                  <TableCell>{r.category}</TableCell>
                  <TableCell style={{ fontWeight: 600 }}>
                    {r.final_puan}
                  </TableCell>
                  <TableCell>
                    {categoryRankByUid.get(r.uid) || "-"}
                    {r.final_derecesi !== categoryRankByUid.get(r.uid) && (
                      <Chip
                        size="small"
                        label={
                          r.final_derecesi
                            ? `kayıtlı: ${r.final_derecesi}`
                            : "kaydedilmedi"
                        }
                        style={{
                          marginLeft: 6,
                          backgroundColor: "#fdf0e0",
                          color: "#c66500",
                        }}
                      />
                    )}
                  </TableCell>
                  <TableCell>
                    {r.final_derecesi >= 1 && r.final_derecesi <= 5 ? (
                      <Checkbox
                        size="small"
                        color="secondary"
                        checked={!!r.odul_gonderilecek}
                        disabled={isLoading}
                        onChange={() => handleToggleOdul(r)}
                      />
                    ) : (
                      r.odul_gonderilecek && (
                        <Chip
                          size="small"
                          label="ilk 5 dışında"
                          style={{
                            backgroundColor: "#fdf0e0",
                            color: "#c66500",
                          }}
                        />
                      )
                    )}
                  </TableCell>
                  <TableCell style={{ whiteSpace: "nowrap" }}>
                    <Button
                      size="small"
                      color="secondary"
                      style={{ textTransform: "none" }}
                      onClick={() => {
                        setUidInput(r.uid);
                        setScoreInput(String(r.final_puan));
                        setPreviewUser(null);
                        window.scrollTo({ top: 0, behavior: "smooth" });
                      }}
                    >
                      Düzenle
                    </Button>
                    <Button
                      size="small"
                      color="error"
                      style={{ textTransform: "none" }}
                      disabled={isLoading}
                      onClick={() => handleDelete(r)}
                    >
                      Sil
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
              {rankedRows.length === 0 && !isLoading && (
                <TableRow>
                  <TableCell colSpan={8} style={{ color: "#777" }}>
                    Henüz puan girilmemiş.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <ToastContainer />
    </div>
  );
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Typography component="div">{children}</Typography>}
    </div>
  );
}
